import { gql } from "@apollo/client";

export const GET_ALL_BIOMETRIC = gql`
  query GetAllBiometric(
    $employeeId: Int
    $employeeName: String
    $status: String
    $shiftName: String
    $attendanceDate: String
    $inTime: String
    $outTime: String
    $workDur: String
    $ot: String
    $page: Int
    $pageSize: Int
  ) {
    getAllBiometric(
      employeeId: $employeeId
      employeeName: $employeeName
      status: $status
      shiftName: $shiftName
      attendanceDate: $attendanceDate
      inTime: $inTime
      outTime: $outTime
      workDur: $workDur
      ot: $ot
      page: $page
      pageSize: $pageSize
    ) {
      totalCount
      records {
        id
        employeeName
        employmentType
        overTime
        duration
        employeeId
        shiftName
        attendanceDate
        punchRecords
        status
        shiftOutTime
        shiftInTime
        attendanceStatus
      }
    }
  }
`;
